import React, { Component } from "react";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables-bitozen";
import LoadingBar from "react-top-loading-bar";
import PopUp from "../../../pages/PopUpAlert";
import API from "../../../../Services/Api";
import { checkResponseError } from "../../../../Services/Utils";
import { connect } from "react-redux";
import * as R from "ramda";
import { Redirect } from "react-router-dom";
import AuthAction from "../../../../Redux/AuthRedux";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import SimpleDate from "../../../../modules/SimpleDate";
import M from "moment";

import Formdelivery from "./formPDI";
import DDLCompany from "../../../../modules/commons/DDLCompany";
import SimpleInput from "../../../../modules/SimpleInput";

import Button from "../../../../modules/commons/Button";
import moment from "moment";
import SimpleSearch from "../../../../modules/SimpleSearch";
import FormPDI from "./formPDI";
const UtilsButtonLogin = require("../../../../Services/UtilsButtonLogin");

const ct = require("../../../../modules/custom/customTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions6();

class PDI extends Component {
  constructor() {
    super();
    this.state = {
      rawData: [],
      dataTable:[],
      dataTable: [
        [
          "1",
          "No SPK 1",
          "Customer 1",
          "DD-MM-YYYY",
          "New PCX 150 ABS",
          "Black",
          "124abs",
          "567efd",
          "12345",
        ],
        [
          "2",
          "No SPK 2",
          "Customer 2",
          "01-01-2022",
          "New PCX 150 ABS",
          "White",
          "456def",
          "789ghi",
          "23456",
        ],
        [
          "3",
          "No SPK 3",
          "Customer 3",
          "02-01-2022",
          "New PCX 150 ABS",
          "Red",
          "789ghi",
          "012abc",
          "34567",
        ],
        [
          "4",
          "No SPK 4",
          "Customer 4",
          "03-01-2022",
          "New PCX 150 ABS",
          "Blue",
          "012abc",
          "234bcd",
          "45678",
        ],
        [
          "5",
          "No SPK 5",
          "Customer 5",
          "04-01-2022",
          "New PCX 150 ABS",
          "Green",
          "234bcd",
          "345cde",
          "56789",
        ],
        [
          "6",
          "No SPK 6",
          "Customer 6",
          "05-01-2022",
          "New PCX 150 ABS",
          "Yellow",
          "345cde",
          "456def",
          "67890",
        ],
        [
          "7",
          "No SPK 7",
          "Customer 7",
          "06-01-2022",
          "New PCX 150 ABS",
          "Orange",
          "567def",
          "678efg",
          "78901",
        ],
        [
          "8",
          "No SPK 8",
          "Customer 8",
          "07-01-2022",
          "New PCX 150 ABS",
          "Purple",
          "678efg",
          "789fgh",
          "89012",
        ],
        [
          "9",
          "No SPK 9",
          "Customer 9",
          "08-01-2022",
          "New PCX 150 ABS",
          "Pink",
          "789fgh",
          "890ghi",
          "90123",
        ],
        [
          "10",
          "No SPK 10",
          "Customer 10",
          "09-01-2022",
          "New PCX 150 ABS",
          "Gray",
          "890ghi",
          "901hij",
          "01234",
        ],
        [
          "11",
          "No SPK 11",
          "Customer 11",
          "10-01-2022",
          "New PCX 150 ABS",
          "Silver",
          "901hij",
          "012ijk",
          "12345",
        ],
        [
          "12",
          "No SPK 12",
          "Customer 12",
          "11-01-2022",
          "New PCX 150 ABS",
          "Gold",
          "012ijk",
          "123jkl",
          "23456",
        ],
        [
          "13",
          "No SPK 13",
          "Customer 13",
          "12-01-2022",
          "New PCX 150 ABS",
          "Brown",
          "123jkl",
          "234klm",
          "34567",
        ],
        [
          "14",
          "No SPK 14",
          "Customer 14",
          "13-01-2022",
          "New PCX 150 ABS",
          "Cyan",
          "234klm",
          "345lmn",
          "45678",
        ],
        [
          "15",
          "No SPK 15",
          "Customer 15",
          "14-01-2022",
          "New PCX 150 ABS",
          "Magenta",
          "345lmn",
          "456mno",
          "56789",
        ],
        [
          "16",
          "No SPK 16",
          "Customer 16",
          "15-01-2022",
          "New PCX 150 ABS",
          "Turquoise",
          "456mno",
          "567nop",
          "67890",
        ],
        [
          "17",
          "No SPK 17",
          "Customer 17",
          "16-01-2022",
          "New PCX 150 ABS",
          "Lime",
          "567nop",
          "678opq",
          "78901",
        ],
        [
          "18",
          "No SPK 18",
          "Customer 18",
          "17-01-2022",
          "New PCX 150 ABS",
          "Teal",
          "678opq",
          "789pqr",
          "89012",
        ],
        [
          "19",
          "No SPK 19",
          "Customer 19",
          "18-01-2022",
          "New PCX 150 ABS",
          "Indigo",
          "789pqr",
          "890qrs",
          "90123",
        ],
        [
          "20",
          "No SPK 20",
          "Customer 20",
          "19-01-2022",
          "New PCX 150 ABS",
          "Violet",
          "890qrs",
          "901rst",
          "01234",
        ],
        [
          "21",
          "No SPK 21",
          "Customer 21",
          "20-01-2022",
          "New PCX 150 ABS",
          "Maroon",
          "901rst",
          "012stu",
          "12345",
        ],
      ],
      selectedIndex: [],
      createVisible: false,
      updateVisible: false,
      deletePopUpVisible: false,
      savePopUpVisible: false,
      loadSave: false,
      allowResize: false,
      defaultSize: 0,
      minSize: 0,
      maxSize: 0,
      timeout: 1000 * 100 * 9,
      isTimedOut: false,
      toCount: 0,
      table_limit: 10,
      table_page: 0,
      table_query: "",
      createVisible2: false,
      tabIndex: 0,
      checkTab: false,
      data: {},
      dataDto: {},
      buttonAccess: {},
    };
    this.idleTimer = null;
  }

  logout() {
    this.props.authLogout();
    return <Redirect to={{ pathname: "/" }} />;
  }

  onAction() {
    this.setState({ isTimedOut: false });
  }

  onActive() {
    this.setState({ isTimedOut: false });
  }

  onIdle() {
    const isTimedOut = this.state.isTimedOut;
    if (isTimedOut) {
      alert("Your session has timed out. Please log in again");
      this.logout();
    } else {
      this.idleTimer.reset();
      this.setState({ isTimedOut: true });
    }
  }

  componentDidMount() {
    UtilsButtonLogin.buttonAccess("MASTER-022", (response) => {
      // console.log("ORI ", response);
      this.setState(
        {
          buttonAccess: response,
        },
        () => {
          this.getCountPage(this.state.table_page, this.state.table_limit);
        }
      );
    });
  }

  getCountPage = async (page, limit) => {
    let payload = {
      limit: limit,
      offset: page,
      filter: this.state.table_query,
      companyId: this.state.dataDto.companyId,
      companyGroupId: null,
      category: null,
      isActive: null,
      sortBy: this.state.dataDto.sortBy ?? "",
      orderBy: this.state.dataDto.orderBy ?? "",
    };

    let res = await API.create("LOCAL_DELIVERY").getDelivery(payload);
    if (res.ok) {
      if (res.data.data === null) {
        this.setState({ dataTable: [] });
      } else {
        // console.log(JSON.stringify(res.data.data, null, 2));
        let dataTable =
          res.data.data &&
          res.data.data.map((value) => {
            const {
              noid,
              nospk,
              namacustomer,
              tgldelivery,
              unittype,
              warna,
              noka,
              nosin,
              nopickship,
            } = value;
            return [
              noid,
              nospk,
              namacustomer,
              tgldelivery,
              unittype,
              warna,
              noka,
              nosin,
              nopickship,
            ];
          });
          console.log('datatable', dataTable)
        this.setState({
          rawData: res.data.data && res.data.data.listUser,
          dataTable,
          toCount: res.data.data && res.data.data.dataOfRecord,
        });
        this.onFinishFetch();
      }
    }
  };

  handleClearUser = (e) => {
    this.setState(
      {
        table_page: 0,
        toCount: 0,
        data: {},
        dataDto: {},
      },
      () => {
        this.getCountPage(this.state.table_page, this.state.table_limit);
      }
    );
  };

  handleSearch = (eventSearch) => {
    this.setState(
      {
        table_page: 0,
        dataDto: eventSearch ? this.state.data : this.state.dataDto,
      },
      () => {
        this.getCountPage(this.state.table_page, this.state.table_limit);
      }
    );
  };

  isLoad(visible) {
    this.setState({ loadSave: visible });
  }

  checkResponse(res, type) {
    if (res.ok && res.data.status === "S") {
      type === "delete" && this.setState({ deletePopUpVisible: false });
      setTimeout(() => {
        this.openSavePopUp();
      }, 500);
    } else {
      this.isLoad(false);
      checkResponseError(res);
    }
  }

  handleSubmit = async (response) => {
    this.checkResponse(response);
  };

  handleDelete = async () => {
    this.isLoad(true);
    let payload = { ...this.state.rawData[this.state.selectedIndex] };
    payload.action = "DELETE";

    let response = await API.create("MASTERDATA_EKSAD").postSaveUser(payload);
    this.checkResponse(response, "delete");
    this.isLoad(false);
  };

  handlePopUp = () => {
    this.handleSearch();
    this.setState({
      savePopUpVisible: false,
      createVisible: false,
      createVisible2: false,
    });
  };

  onChangeDate = (e, name) => {
    this.setState({
      data: {
        ...this.state.data,
        [name]: M(e).format("DD-MM-YYYY"),
      },
    });
  };

  startFetch = () => {
    this.LoadingBar.continousStart();
  };

  onFinishFetch = () => {
    if (typeof this.LoadingBar === "object") this.LoadingBar.complete();
  };

  openCreateForm = () => {
    this.setState({ createVisible: !this.state.createVisible });
  };

  openUpdateForm = () => {
    this.setState({ updateVisible: !this.state.updateVisible });
  };

  openSavePopUp = () => {
    this.setState({
      savePopUpVisible: !this.state.savePopUpVisible,
      loadSave: false,
    });
  };

  openDeletePopup = (index) => {
    this.setState({
      deletePopUpVisible: !this.state.deletePopUpVisible,
      selectedIndex: index,
    });
  };

  columnsUser = [
    { name: "#" },
    { name: "No. WO" },
    { name: "Nama Customer" },
    { name: "Tgl Service" },
    { name: "Unit Type" },
    { name: "Warna" },
    { name: "NoKa" },
    { name: "NoSin" },
    { name: "Notes" },
    {
      name: "Aksi",
      options: {
        customBodyRender: (val, tableMeta) => {
          return (
            <div style={{ width: "115px" }}>
              <Button
                className="btnAct"
                style={{  backgroundColor: "transparent" }}
                onClick={this.openCreateForm.bind(this)}
                permission=""
              >
                <span style={{ color: "red", fontSize: 14 }}>
                  <u>Final Check</u>
                </span>
              </Button>
            </div>
          );
        },
      },
    },

    // {
    //     name: "Action",
    //     options: {
    //         customBodyRender: (val, tableMeta) => {
    //             return (
    //                 <div style={{ width: '115px' }}>
    //                     <Button
    //                         className="btnAct"
    //                         style={{ marginRight: 15, backgroundColor: 'transparent' }}
    //                         onClick={this.opSidePage('slide-menu-1', tableMeta.rowIndex, 'companyGroup')}
    //                         permission=""
    //                     >
    //                         <i className="fa fa-lw fa-pencil-alt"
    //                             style={{ backgroundColor: 'transparent', color: '#004c97', fontSize: 20 }} />
    //                     </Button>
    //                     {/* <Button
    //                         className="btnAct"
    //                         style={{ marginRight: 15, backgroundColor: 'transparent' }}
    //                         onClick={() => this.openDeletePopup(tableMeta.rowIndex)}
    //                         permission={this.state.buttonAccess.btnDelete}
    //                     >
    //                         <i className="fa fa-lw fa-trash-alt"
    //                             style={{ backgroundColor: 'transparent', color: 'red', fontSize: 20 }} />
    //                     </Button> */}
    //                     <Button
    //                         className="btnAct"
    //                         style={{ marginRight: 15, backgroundColor: 'transparent' }}
    //                         onClick={this.opSidePage('slide-menu-view', tableMeta.rowIndex)}
    //                         permission=""
    //                     >

    //                         <i className="fa fa-lw fa-ellipsis-v"
    //                             style={{ backgroundColor: 'transparent', color: '#004c97', fontSize: 20 }} />
    //                     </Button>
    //                 </div>
    //             );
    //         }
    //     }
    // }
  ];

  onchangeInput = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    this.setState({
      data: {
        ...this.state.data,
        [name]: value,
      },
    });
  };

  opSidePage = (menu, data) => (e) => {
    e.preventDefault();
    let selectedIndex = data;
    this.setState({
      updateVisible: false,
    });

    switch (menu) {
      case "slide-menu-1":
        this.setState({
          updateVisible: true,
          selectedIndex,
          popupType: "update",
        });
        break;
      case "slide-menu-view":
        this.setState({
          updateVisible: true,
          selectedIndex,
          popupType: "view",
        });
        break;
      default:
        break;
    }
  };
  resetTab = (tabIndex) => {
    this.setState({ tabIndex });
    if (tabIndex === 0) {
      this.getCountPage(this.state.table_page, this.state.table_limit);
    }
  };

  render() {
    if (R.isNil(this.props.auth.user))
      return <Redirect to={{ pathname: "/" }} />;
    let { toCount, table_query } = this.state;
    let tableOptions = {
      ...options,
      // serverSide: true,
      filter: false,
      count: toCount,
      searchText: table_query,
      search: false,
      viewColumns: false,
      rowsPerPage: this.state.table_limit,
      page: this.state.table_page,
      onColumnSortChange: (changedColumn, direction) => {
        let order = "desc";
        if (direction === "ascending") {
          order = "asc";
        }

        let columnOrder = "";

        if (changedColumn === "Company") {
          columnOrder = "companyCode";
        }

        if (changedColumn === "Username") {
          columnOrder = "username";
        }

        if (changedColumn === "Email") {
          columnOrder = "email";
        }

        if (changedColumn === "Category") {
          columnOrder = "category";
        }

        if (changedColumn === "Employee Name") {
          columnOrder = "name";
        }

        if (changedColumn === "Status") {
          columnOrder = "status";
        }

        this.columnsUser.map((value, index) => {
          if (changedColumn === value.name && value.name !== "Action") {
            value.options = { sortDirection: order };
          } else {
            value.options = { ...value.options, sortDirection: "none" };
          }
        });

        this.setState(
          {
            dataDto: {
              ...this.state.dataDto,
              sortBy: columnOrder,
              orderBy: order,
            },
          },
          () => {
            this.getCountPage(this.state.table_page, this.state.table_limit);
          }
        );
      },
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.setState({ table_page: tableState.page });
            this.getCountPage(tableState.page, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.setState({ table_limit: tableState.rowsPerPage });
            this.getCountPage(tableState.page, tableState.rowsPerPage);
            break;
          case "search":
            let searchText = tableState.searchText ? tableState.searchText : "";
            this.setState({ table_query: searchText }, () => {
              this.handleSearch();
            });
            break;
          default:
            break;
        }
      },
    };
    return (
      <div className="main-slider">
        <div className="padding-tbl-monitoring">
          <LoadingBar onRef={(ref) => (this.LoadingBar = ref)} />
          <Tabs
            selectedIndex={this.state.tabIndex}
            onSelect={(tabIndex) => this.resetTab(tabIndex)}
          >
            <TabList>
              <Tab>PDI</Tab>
            </TabList>
            <TabPanel>
              <div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <SimpleDate
                    label={"Start Date"}
                    date={this.state.data.startDate}
                    minDate={new Date()}
                    onChange={(date) => this.onChangeDate(date, "startDate")}
                  />
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div style={{ width: 200, marginRight: 20 }}>
                      <DDLCompany
                        label={"No SPK"}
                        box={"search"}
                        hierarchy={false}
                        onChangeCombo={(value) => {
                          this.setState({
                            data: { ...this.state.data, ...value },
                          });
                        }}
                        valueCombo={this.state.data.companyIdSelect}
                      />
                    </div>

                    <div>
                      <SimpleSearch
                        label={"NoKa"}
                        name="noka"
                        // readOnly={this.props.type !== "create"}
                        value={this.state.data.noka}
                        onChange={this.onchangeInput}
                      />
                    </div>
                    <div style={{ width: 100, marginTop: "8px" }}>
                    <Button
                      type="button"
                      style={{ width: "50px", marginTop: "19px" }}
                      className="btn btn-plus background-red margin-left-15px"
                      valueCombo={this.state.data.companyIdSelect}
                      onClick={this.openCreateForm.bind(this)}
                    >
                        <i
                          className="fa fa-qrcode"
                          style={{ alignContent: "center" }}
                        />
                    </Button>
                  </div>
                  </div>
                </div>

                {/* <div className='col-3 padding-top-25px'>
                                    <Button
                                        type='button'
                                        className='btn btn-circle background-red'
                                        style={{ marginRight: 5 }}
                                        onClick={() => this.handleSearch(true)}
                                        permission={this.state.buttonAccess.btnSearch}
                                    >
                                        <i className='fa fa-1x fa-search' />
                                    </Button>
                                    <Button
                                        type='button'
                                        className='btn btn-circle background-red'
                                        style={{ marginRight: 10 }}
                                        onClick={this.handleClearUser}
                                        permission={this.state.buttonAccess.btnClear}
                                    >
                                        <i className='fa fa-1x fa-sync-alt' />
                                    </Button>
                                </div> */}
              </div>
              <div>
                <MuiThemeProvider theme={getMuiTheme()}>
                  <MUIDataTable
                    key={toCount}
                    title={"Delivery Table"}
                    subtitle={"Setting data of Delivery"}
                    data={this.state.dataTable}
                    columns={this.columnsUser}
                    options={tableOptions}
                    // buttonCreate={this.state.buttonAccess.btnAdd}
                    // onCreate={this.openCreateForm.bind(this)}
                  />
                </MuiThemeProvider>
              </div>
            </TabPanel>
          </Tabs>
          <div
            style={{ float: "right", marginRight: "1vw" }}
            className="padding-top-30px padding-bottom-20px"
          >
            {/* <button
              style={{ marginLeft: "15px" }}
              className="btn btn-back"
              type="button"
            >
              <span>BACK</span>
            </button>
            <button
              style={{ marginLeft: "15px" }}
              className="btn btn-back"
              type="button"
              onClick={this.openCreateForm.bind(this)}
            >
              <span>PROCCESS</span>
            </button> */}
          </div>
        </div>

        <div>
          {this.state.createVisible && (
            <FormPDI
              type={"create"}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openCreateForm.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.updateVisible && (
            <FormPDI
              type={this.state.popupType === "update" ? "edit" : "view"}
              data={this.state.rawData[this.state.selectedIndex]}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openUpdateForm.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.savePopUpVisible && (
            <PopUp
              type={"save"}
              class={"app-popup app-popup-show"}
              onClick={this.handlePopUp.bind(this)}
            />
          )}

          {this.state.deletePopUpVisible && (
            <PopUp
              type={"delete"}
              class={"app-popup app-popup-show"}
              onClickDelete={this.handleDelete}
              onClick={this.openDeletePopup}
              isLoading={this.state.loadSave}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    h1Module: state.h1Module,
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authLogout: () => dispatch(AuthAction.authLogout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PDI);
